import { Box, Typography } from '@mui/material';
import { images } from '../../.../../../../shared/lib/assets';
import palette from '../../.../../../../shared/lib/theme/palette';
import { AuthLogoBox } from '../../.../../../../shared/lib/theme/styleComponents';

export const OnBoardingSideBar = () => {
  const { white } = palette;

  return (
    <AuthLogoBox>
      <Box component="img" position="absolute" top="20px" src={images.ON_BOARDING_LOGO} />

      <Box width="256px" height="256px" component="img" src={images.ON_BOARDING_BILLING} />

      <Typography variant="h6" width="364px" sx={{ color: white, fontWeight: '700', p: 2 }}>
        Manage your Trusted Contacts, billing, subscription and account settings.
      </Typography>
    </AuthLogoBox>
  );
};
